
<template>
  <Carousel class="images_home" :images="images" />
</template>

<script>
import Carousel from '@/components/_shared/Carousel.vue'

export default {
  name: 'PageContent',
  components: { Carousel },
  data () {
    return {
      images: [
        'img/slider/home_image.jpg',
        'img/slider/home_image2-min.jpg',
        'img/slider/home_image3-min.jpg',
        'img/slider/home_image4.jpg'
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.kt-login__section {
  background: rgba(0,0,0,.3);
}
.kt-login__title {
  font-size: 3.5rem !important;
  font-weight: 600 !important;
  margin-bottom: .5rem !important;
}
.kt-login__subtitle {
  font-size: 3.3rem;
  font-weight: 300;
  margin-bottom: 2rem !important;
}
.kt-login__desc {
  font-size: 2.2rem !important;
  font-weight: 300 !important;
}
.carousel-item {
  height: 100vh;
}
.carousel-item img {
  object-fit:cover;
}

</style>
